import { _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245 } from './UShort.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from './hacks.mjs';
import { numberToChar93r9buh19yek as numberToChar } from './js/numberConversion.mjs';
import { CharRange1dt3801jgpja5 as CharRange } from './ranges/PrimitiveRanges.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from './js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from './js/void.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from './Comparable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _Char___init__impl__6a9atx(value) {
  return value;
}
function _get_value__a43j40($this) {
  return $this;
}
function _Char___init__impl__6a9atx_0(code) {
  // Inline function 'kotlin.UShort.toInt' call
  var tmp$ret$0 = _UShort___get_data__impl__g0245(code) & 65535;
  return _Char___init__impl__6a9atx(tmp$ret$0);
}
function Char__compareTo_impl_ypi4mb($this, other) {
  return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
}
function Char__compareTo_impl_ypi4mb_0($this, other) {
  return Char__compareTo_impl_ypi4mb($this.f4_1, other instanceof Char() ? other.f4_1 : THROW_CCE());
}
function Char__plus_impl_qi7pgj($this, other) {
  return numberToChar(_get_value__a43j40($this) + other | 0);
}
function Char__minus_impl_a2frrh($this, other) {
  return _get_value__a43j40($this) - _get_value__a43j40(other) | 0;
}
function Char__minus_impl_a2frrh_0($this, other) {
  return numberToChar(_get_value__a43j40($this) - other | 0);
}
function Char__rangeTo_impl_tkncvp($this, other) {
  return new (CharRange())($this, other);
}
function Char__toInt_impl_vasixd($this) {
  return _get_value__a43j40($this);
}
function toString($this) {
  // Inline function 'kotlin.js.unsafeCast' call
  return String.fromCharCode(_get_value__a43j40($this));
}
function Char__equals_impl_x6719k($this, other) {
  if (!(other instanceof Char()))
    return false;
  return _get_value__a43j40($this) === _get_value__a43j40(other.f4_1);
}
function Char__hashCode_impl_otmys($this) {
  return _get_value__a43j40($this);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.g4_1 = _Char___init__impl__6a9atx(0);
        this.h4_1 = _Char___init__impl__6a9atx(65535);
        this.i4_1 = _Char___init__impl__6a9atx(55296);
        this.j4_1 = _Char___init__impl__6a9atx(56319);
        this.k4_1 = _Char___init__impl__6a9atx(56320);
        this.l4_1 = _Char___init__impl__6a9atx(57343);
        this.m4_1 = _Char___init__impl__6a9atx(55296);
        this.n4_1 = _Char___init__impl__6a9atx(57343);
        this.o4_1 = 2;
        this.p4_1 = 16;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CharClass;
function Char() {
  if (CharClass === VOID) {
    class $ {
      constructor(value) {
        Companion_getInstance();
        this.f4_1 = value;
      }
      q4(other) {
        return Char__compareTo_impl_ypi4mb(this.f4_1, other);
      }
      d(other) {
        return Char__compareTo_impl_ypi4mb_0(this, other);
      }
      toString() {
        return toString(this.f4_1);
      }
      equals(other) {
        return Char__equals_impl_x6719k(this.f4_1, other);
      }
      hashCode() {
        return Char__hashCode_impl_otmys(this.f4_1);
      }
    }
    initMetadataForClass($, 'Char', VOID, VOID, [Comparable()]);
    CharClass = $;
  }
  return CharClass;
}
//region block: exports
export {
  _Char___init__impl__6a9atx as _Char___init__impl__6a9atxrzocepzq3zgi,
  _Char___init__impl__6a9atx_0 as _Char___init__impl__6a9atxw2ssnfzfsqzz,
  Char__compareTo_impl_ypi4mb as Char__compareTo_impl_ypi4mb3bl0kdwnivnp6,
  Char__minus_impl_a2frrh as Char__minus_impl_a2frrhw2puetaduxyd,
  Char__minus_impl_a2frrh_0 as Char__minus_impl_a2frrh4e9xgjqbj3za,
  Char__plus_impl_qi7pgj as Char__plus_impl_qi7pgj12gj4qbkhmj1y,
  Char__rangeTo_impl_tkncvp as Char__rangeTo_impl_tkncvpnglpnjmwahwh,
  Char__toInt_impl_vasixd as Char__toInt_impl_vasixd28v1p2u6jau5g,
  toString as toString1n9qg6fb0b5i8,
  Companion_getInstance as Companion_getInstance1genqokpkr3uz,
  Char as Char19o2r8palgjof,
};
//endregion

//# sourceMappingURL=Char.mjs.map
